import { useNavigate } from 'react-router-dom';
import { EditPage, EditPageTextField, EditPagePanel } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PaymentTermEdit = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [defaultCurrency, setDefaultCurrency] = useState({});
    const { payment_term_id } = useParams();
    useEffect(() => {
        getOne('/admin/settings/payment_terms/', payment_term_id).then(response => {
            setData(response.data.data);
        });
        getOne('/admin/settings/payment_terms/', 1).then(response => {
            setDefaultCurrency(response.data.data);
        });
    }, [payment_term_id]);

    const handleSave = () => {
        update('/admin/settings/payment_terms/', payment_term_id, {data: data}).then(response => {
            toast.success("Payment term updated successfully", {});
            navigate('/settings/payment_terms');
        }).catch(error => {
            toast.error("Error updating payment term: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/settings/payment_terms');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update Payment Term (${data.name})`} >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageTextField label="Cycle Days" id="days_cycle" onChange={ onChange } value={ data.days_cycle } />
                    <EditPageTextField label="Grace Days" id="days_grace" onChange={ onChange } value={ data.days_grace } />
                    <EditPageTextField label="Notify Days (comma separated)" id="days_notify" onChange={ onChange } value={ data.days_notify } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default PaymentTermEdit;